const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/email/send-config/channel.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { EmailSendConfigTplConfigFilterParamSchema } from '@apps/main/features/admin/pages/email/send-config-tpl-config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/email/send-config/channel')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: EmailSendConfigTplConfigFilterParamSchema
});